import { CardMedia, styled } from '@mui/material';

export const VideoStyled = styled(CardMedia)(({ theme }) => ({
  border: 'none',
  height: '139px',

  [theme.breakpoints.up('md')]: {
    height: '200px',
  },
}));
